import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutUs,
  getAch_and_ack,
  getContent,
} from "../../features/aboutus/aboutusSlice";
import OurJourney from "./ourJourney/OurJourney";
import Reels from "../home/reels/Reels";

function About_us() {
  const about_us = useSelector((state) => state.aboutus.about_us);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const ach_and_ack = useSelector((state) => state.aboutus.ach_and_ack);

  useEffect(() => {
    dispatch(getAch_and_ack());
  }, [dispatch]);

  
  return (
    <>
      {/* <Farm_vdo about_us={about_us} /> */}
      {/* <About_Info about_us={about_us} /> */}
      <OurJourney about_us={about_us} />
      {/* <WhyLoveUs /> */}
      {/* <About_us_card_content />
      {ach_and_ack?.data?.length > 0 && (
        <Achievements_and_acknowledgments ach_and_ack={ach_and_ack} />
      )}

      <Founding_farmers /> */}
      {/* <Stay_Connected /> */}

    </>
  );
}

export default About_us;
